const SCHEMA_TYPE = {
  NATIVE: 'NATIVE',
  CUSTOM: 'CUSTOM',
  CUSTOM_LIST: 'CUSTOM_LIST',
  NATIVE_LIST: 'NATIVE_LIST',
};

export default SCHEMA_TYPE;
